import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-[#0d0d0d] border-t border-[#2a2a2a] mt-12">
      <div className="max-w-6xl mx-auto px-4 py-8">
        <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-400 mb-4">
          <Link to="/about" className="hover:text-cyan-400 transition-colors">About</Link>
          <span className="text-[#2a2a2a]">|</span>
          <Link to="/sitemap" className="hover:text-cyan-400 transition-colors">Sitemap</Link>
          <span className="text-[#2a2a2a]">|</span>
          <Link to="/terms" className="hover:text-cyan-400 transition-colors">Terms of Use</Link>
          <span className="text-[#2a2a2a]">|</span>
          <Link to="/privacy" className="hover:text-cyan-400 transition-colors">Privacy Policy</Link>
          <span className="text-[#2a2a2a]">|</span>
          <Link to="/contact" className="hover:text-cyan-400 transition-colors">Contact</Link>
        </div>
        <p className="text-center text-xs text-gray-500">
          © 2025 PercentageCalculatorPlus.com | All Rights Reserved
        </p>
      </div>
    </footer>
  );
};

export default Footer;
